export enum ApplicationRole {
  Unknown = '',
  StateProgramOffice = 'State Program Office',
  StateHelpdesk = 'State Helpdesk',
  SchoolAttendanceOfficer = 'School Attendance Officer',
}
